import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../Axios/AxiosInstance';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Login.css';
import { TextConstants } from '../Constants/Constants';

const Login = () => {

  const navigate = useNavigate();

  const [empId, setEmpId] = useState('');
  const [password, setPassword] = useState('');
  const [empIdError, setEmpIdError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let hasError = false;
    setEmpIdError('');
    setPasswordError('');
    
    if (!empId) {
      setEmpIdError('Employee ID is required');
      hasError = true;
    }
    if (!password) {
      setPasswordError('Password is required');
      hasError = true;
    }
    if (hasError) {
      return;
    }
  
    const input = { EmployeeId: empId.toUpperCase(), Password: password };
    try {
      setLoading(true);
      const authResponse = await axios.post('https://hrdetails.nipponpaint.co.in/api/Employee/Authenticate', input);
      
      if (authResponse.status === 300) {
        toast.error('Sorry Employeeid Not Matching');
        setPassword("");
        setEmpId("");
        return;
      }
      
      if (authResponse.data) {
        if (authResponse.data.Status !== "No Results Found") {
          const empId = input.EmployeeId;
          const adminResponse = await axiosInstance.get(`admin/AdminLogin?empId=${empId}`);
          if (adminResponse.data.token) {
            sessionStorage.setItem('token', adminResponse.data.token);
            const userInfo = {
              employeeName: adminResponse.data.employeeName,
              employeeId: adminResponse.data.employeeId,
              rolename: adminResponse.data.rolename,
              roleId: adminResponse.data.roleId,
              email: adminResponse.data.email,
              mobile: adminResponse.data.mobile
            };
            sessionStorage.setItem('userinfo', JSON.stringify(userInfo));
            setPassword("");
            setEmpId("");
            toast.success('Login successfully');
            navigate('/dashboard', { replace: true });
          } else {
            toast.error('Login failed, please try again.');
            setPassword("");
            setEmpId("");
          }
        } else {
          toast.error('Invalid credentials or user not found.');
          setPassword("");
          setEmpId("");
        }
      } else {
        toast.error('Invalid credentials');
      }
    } catch (err) {
      toast.error(err.response?.data?.value || 'An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="outer-container">
      <div className="inner-container">
        <div className="image-container"></div>
        <div className="login-container">
          <h2>{TextConstants.login}</h2>
          <form onSubmit={handleSubmit} className="form">
            <div className="input-group">
              <label htmlFor="empId">{TextConstants.empId} :</label>
              <input
                type="text"
                id="empId"
                value={empId}
                onChange={(e) => {
                  setEmpId(e.target.value);
                  if (e.target.value) {
                    setEmpIdError('');
                  }
                }}
                placeholder={empIdError || "Enter Emp Id"}
                className={`input ${empIdError ? 'error' : ''}`}
              />
            </div>
            <div className="input-group">
              <label htmlFor="password">{TextConstants.password} :</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  if (e.target.value) {
                    setPasswordError('');
                  }
                }}
                placeholder={passwordError || "Enter Password"}
                className={`input ${passwordError ? 'error' : ''}`}
              />
            </div>
            <button type="submit" className="login_button" disabled={loading}>
              <div className="login_button-content">
                {loading && <div className="loginloader"></div>}
                <span>{loading ? '' : 'Login'}</span>
              </div>
            </button>
          </form>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Login;
